import * as React from "react";
function SvgShare(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <g
        fill="none"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={2}
        stroke="currentColor"
      >
        <path d="M1 29v-8A12 12 0 0113 9h18M31 9l-6-6M25 15l6-6" />
      </g>
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgShare);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
